module.exports = __webpack_public_path__ + "static/media/zefir.b86b1c2f.jpg";